var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0417 36.75V33.25C29.0417 31.3935 28.3218 29.613 27.0403 28.3003C25.7588 26.9875 24.0207 26.25 22.2084 26.25H8.54171C6.7294 26.25 4.99131 26.9875 3.70981 28.3003C2.42831 29.613 1.70837 31.3935 1.70837 33.25V36.75",
    stroke: "#2B2F51",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.375 19.25C19.1489 19.25 22.2083 16.116 22.2083 12.25C22.2083 8.38401 19.1489 5.25 15.375 5.25C11.601 5.25 8.54163 8.38401 8.54163 12.25C8.54163 16.116 11.601 19.25 15.375 19.25Z",
    stroke: "#2B2F51",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2916 36.75V33.25C39.2905 31.6991 38.7866 30.1924 37.859 28.9666C36.9314 27.7408 35.6326 26.8653 34.1666 26.4775",
    stroke: "#2B2F51",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3334 5.47754C28.8032 5.86307 30.1061 6.73877 31.0364 7.96658C31.9668 9.1944 32.4718 10.7045 32.4718 12.2588C32.4718 13.8131 31.9668 15.3232 31.0364 16.551C30.1061 17.7788 28.8032 18.6545 27.3334 19.04",
    stroke: "#2B2F51",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.9568e89449fc797098f5a224bc761b14.svg";
export { ForwardRef as ReactComponent };